import { Layout } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';
import Footer from '~/pages/layouts/Footer';
import Header from '~/pages/layouts/Header';
import NavBar from '~/pages/layouts/NavBar';

const { Content } = Layout;

type IProps = {
  children: ReactNode;
};

function DefaultLayout({ children }: IProps) {
  return (
    <>
      <Layout style={{ minHeight: '100vh', width: 'auto' }}>
        <NavBar />
        <Layout>
          <SContent>
            <Header />
            {children}
          </SContent>
          <Footer />
        </Layout>
      </Layout>
    </>
  );
}

export default DefaultLayout;

const SContent = styled(Content)`
  padding: 10px;
  display: flex;
  flex-direction: column;
`;
//  padding: 2%;
/*
 <>
      <Layout style={{ minHeight: '100vh' }}>
        <NavBar />
        <Layout>
          <SContent>
            <Header />
            {children}
          </SContent>
          <Footer />
        </Layout>
      </Layout>
    </>
*/
